import React, { useEffect } from "react";
// import closeBtn from "../asset/images/close.svg";
import favicon from "../asset/images/favicon.svg";
import logo from "../asset/images/logo.svg";
// import logo from "../asset/images/Bajaj_logo_login.svg";
import whitLogo from "../asset/images/bajaj_finserve_logo_white.svg";
import whiteLogoSmall from "../asset/images/bajaj_finserve_logo_white_s.svg";
import { Link } from "react-router-dom";
import { useState } from "react";
import { toggleSidebar } from "../CommonMethhods/CommonMethods";
import { Constants } from "../CommonMethhods/Constants";

function Sidebar(props) {
  const [reportTab, setReportTab] = useState(false);
  const [lasTab, setLasTab] = useState(false);
  const [subCompliance, setSubCompliance] = useState(false);
  // let sideOnboarding = props.SidebarDetails;
  // let navigate = useNavigate();
  const closeToggleSidebar = () => {
    document
      .querySelectorAll(".side-blue")
      .forEach((el) => (el.childNodes[1].style.display = "none"));
    let closeSidebar = document.getElementById("sidenav");
    let body2 = document.getElementById("root");
    closeSidebar.classList.remove("toggle-nav");
    body2.classList.remove("show-overlay");
    setSubCompliance(false);
    setReportTab(false);
    setSubCompliance(false);
    setLasTab(false);
  };

  //to handle reports tab
  const handleReportsClick = () => {
    toggleSidebar();
    removetooltip();
    setReportTab(!reportTab);
  };

  // const handleLas = () => {
  //   toggleSidebar();
  //   if (lasTab) {
  //     alert("close")
  //     setLasTab(false)
  //   } else {
  //     alert("open")
  //     setLasTab(true)
  //   }
  // }

  // for active sidebar icon

  useEffect(() => {
    // alert(window.location.pathname.slice(1));
    let CurrentEle = window.location.pathname.slice(1);
    document
      .querySelectorAll(".side-blue")
      .forEach((el) => el.classList.remove("active"));
    switch (CurrentEle) {
      case "dashboard":
        document.querySelector(`.dashboard`).classList.add("active");
        break;
      case "onboarding":
        document.querySelector(`.onboarding`).classList.add("active");
        break;
      case "rm-mapping":
        document.querySelector(`.rm-mapping`).classList.add("active");
        break;
      case "ap-master":
        document.querySelector(`.ap-master`).classList.add("active");
        break;
      case "ap-payout":
        document.querySelector(`.ap-payout`).classList.add("active");
        break;
      case "rms":
        document.querySelector(`.rms`).classList.add("active");
        break;
      case "knowledge-center":
        document.querySelector(`.knowledge-center`).classList.add("active");
        break;
      case "FAQ's":
        document.querySelector(`.FAQ`).classList.add("active");
        break;

      case "contact-us":
        document.querySelector(`.ContactUs`).classList.add("active");
        break;
      case "family-master":
        document.querySelector(`.FamilyMaster`).classList.add("active");
        break;
      case "ipo-master":
        document.querySelector(`.IPOMaster`).classList.add("active");
        break;

      case "telecaller":
        document.querySelector(`.tele`).classList.add("active");
        break;

      case "banking":
        document.querySelector(`.Banking`).classList.add("active");
        break;

      case "finance-rights":
        document.querySelector(`.AccountRights`).classList.add("active");
        break;
      default:
        // document.querySelector(`.dashboard`).classList.add("active");
        break;
    }
  }, [window.location.pathname]);

  function subLasOpen() {
    setLasTab(!lasTab);
  }
  function subComplianceOpen() {
    setSubCompliance(!subCompliance);
  }

  const hoverFunction = (e, data) => {
    let sideWidth = document.getElementById("sidenav");
    if (sideWidth.clientWidth < 100) {
      let toolBase = e.target.getBoundingClientRect();
      let topReq = toolBase.y + "px";
      const tooltip = document.createElement("span");
      tooltip.classList.add("sideToolTip");
      tooltip.innerText = data;
      tooltip.style.position = "fixed";
      tooltip.style.top = topReq;
      tooltip.style.left = "90px";
      document.body.appendChild(tooltip);
    } else {
      let toolElement = document.querySelectorAll(".sideToolTip");
      if (toolElement) {
        for (let ele = 0; ele <= toolElement.length - 1; ele++) {
          toolElement[ele].remove();
        }
      }
    }
  };

  const removetooltip = () => {
    // let sideWidth = document.getElementById("sidenav");
    // if (sideWidth.clientWidth < 100) {
    // let toolElement = document.querySelector(".sideToolTip");
    // toolElement.remove();
    let toolElement = document.querySelectorAll(".sideToolTip");
    if (toolElement) {
      for (let ele = 0; ele <= toolElement.length - 1; ele++) {
        toolElement[ele].remove();
      }
    }
    // }
  };

  return (
    <>
      {/* <!-- Side Menu --> */}
      <div className="main-menu" id="sidenav">
        <div className="close-icon" onClick={closeToggleSidebar}>
          <span className="icon-close"></span>
        </div>

        <div className="main-logo">
          <a href="/dashboard">
            <img src={logo} alt="logo" className="logo1" />
            <img src={favicon} alt="" className="logo2" />
            <img src={whitLogo} alt="" className="whitelogo" />
            <img src={whiteLogoSmall} alt="" className="whitelogos" />
          </a>
        </div>
        <div className="menu-list">
          {window.location.pathname === "/telecaller" ||
          window.location.pathname === "/telecallerPage" ? (
            <ul>
              <li>
                <Link
                  to="/telecaller"
                  className="side-blue knowledge-center tele"
                >
                  {/* <span className="icon-knowledge-center"></span> */}
                  <span className="icon-telecaller_icon"></span>
                  {/* <img src={telecallerIcon} alt="" className="telecaller_icon" /> */}
                  <i>TeleCaller</i>
                </Link>
              </li>
            </ul>
          ) : (
            <ul>
              <li
                onMouseEnter={(e) => hoverFunction(e, "Dashboard")}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to={"/dashboard"} className="side-blue dashboard">
                  <span className="icon-block-menu "></span>
                  <i>{Constants.Dashboard}</i>
                </Link>
                {/* <span className="side-hover-menu">
                  <i>{Constants.Dashboard}</i>
                </span> */}
              </li>
              <li
                onMouseEnter={(e) => hoverFunction(e, "Onboarding")}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to="/onboarding" className="side-blue onboarding">
                  <span className="icon-onboardingsvg "></span>

                  <i>{Constants.Onboarding}</i>
                </Link>
                {/* <span className="side-hover-menu">
                  <i>{Constants.Onboarding}</i>
                </span> */}
              </li>
              <li
                // className={reportTab ? "dropdown dropdown-active" : "dropdown"}
                className="dropdown"
                onMouseEnter={(e) => hoverFunction(e, "Reports")}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <a
                  role="button"
                  onClick={() => {
                    handleReportsClick();
                  }}
                  className="side-blue"
                >
                  <span className="icon-report1"></span>
                  <i>{Constants.Reports}</i>
                  <span
                    className={
                      reportTab
                        ? "icon-down-triangle down-arrow"
                        : "icon-right-triangle down-arrow down-arrow-new"
                    }
                  ></span>
                </a>
                {/* <span className="side-hover-menu">
                  <i>{Constants.Reports}</i>
                </span> */}
                {reportTab && (
                  <div className="sub-menu">
                    <ul>
                      <>
                        <li>
                          <Link to="/single-holding">
                            {Constants.Single_Holding_Report}
                          </Link>
                        </li>
                        <li>
                          <Link to="/hierarchy-report">
                            {Constants.Hierarchy_Report}
                          </Link>
                        </li>
                      </>

                      <li>
                        <Link to="/aum-report">
                          {Constants.Client_Wise_AUM_Report}
                        </Link>
                      </li>
                      <li>
                        <Link to="/clientwise-revenue-report">
                          {Constants.Client_Wise_Revenue_Report}
                        </Link>
                      </li>
                      <li>
                        <Link to="/revenue-report">Revenue Report</Link>
                      </li>

                      {/* <li>
                        <a role="button" onClick={() => subLasOpen()}>
                          LAS{" "}
                          <span
                            className={
                              lasTab
                                ? "icon-down-triangle down-arrow"
                                : "icon-right-triangle down-arrow down-arrow-new"
                            }
                          ></span>
                        </a>
                        {lasTab && (
                          <div className="sub-menu">
                            <ul>
                              <li>
                                <Link to="/soa-report">SOA</Link>
                              </li>
                              <li>
                                <Link to="/ivr-report">IVR</Link>
                              </li>
                            </ul>
                          </div>
                        )}
                      </li> */}

                      <li>
                        <Link to="/ledger-report">
                          {Constants.Financial_Ledger_Report}
                        </Link>
                      </li>
                      <li>
                        <Link to="/combine-ledger-report">
                          {Constants.Combine_Ledger_Report}
                        </Link>
                      </li>
                      <li>
                        <Link to="/tradeSummary-report">
                          {Constants.Trade_Summary_Report}
                        </Link>
                      </li>
                      <li>
                        <Link to="/p&l-report">{Constants.Pnl_Report}</Link>
                      </li>
                      <li>
                        <Link to="/contractlist">
                          {Constants.Get_Contract_List_Report}
                        </Link>
                      </li>
                      <li>
                        <Link to="/levies-report">
                          {Constants.Levies_Report}
                        </Link>
                      </li>
                      <li>
                        <Link to="/dividend-report">
                          {Constants.Dividend_Report}
                        </Link>
                      </li>
                      <li>
                        <Link to="/morning-limits">
                          {Constants.Morning_Limit_Report}
                        </Link>
                      </li>
                      <li>
                        <Link to="/client-holding">
                          {Constants.Holding_Statement}
                        </Link>
                      </li>
                      <li>
                        <Link to="/interest-report">Interest Report</Link>
                      </li>
                      <li>
                        <Link to="/tax-report">{Constants.Tax_Report}</Link>
                      </li>

                      <li>
                        <Link to="/dp-transaction-report">
                          DP Transaction Report
                        </Link>
                      </li>
                      <li>
                        <Link to="/yield-report">Yield Report</Link>
                      </li>
                      <li>
                        <Link to="/mtf-details-report">
                          {Constants.MTF_Details_Report}
                        </Link>
                      </li>
                      <li>
                        <Link to="/pledge-master-report">
                          Pledge Master Report
                        </Link>
                      </li>
                      <li>
                        <Link to="/delaypayment-report">
                          {Constants.Delay_Payment_Report}
                        </Link>
                      </li>
                      <li>
                        <Link to="/daysToLongTerm-report">
                          Days To Long Term Report
                        </Link>
                      </li>
                      <li>
                        <Link to="/margin-shortage-report">
                          Margin Shortage Report
                        </Link>
                      </li>
                      <li>
                        <Link to="/tentative-margin">
                          {Constants.Tentative_Margin_Report}
                        </Link>
                      </li>

                      <li>
                        <Link to="/aging-report">Aging Report</Link>
                      </li>

                      <>
                        <li>
                          <Link to="/pledge">Pledge</Link>
                        </li>
                      </>

                      <li>
                        <a role="button" onClick={() => subComplianceOpen()}>
                          Compliance
                          <span
                            className={
                              subCompliance
                                ? "icon-down-triangle down-arrow"
                                : "icon-right-triangle down-arrow down-arrow-new"
                            }
                          ></span>
                        </a>
                        {subCompliance && (
                          <div className="sub-menu">
                            <ul>
                              <li>
                                <Link to="/income-declaration">
                                  Income Declaration
                                </Link>
                              </li>
                            </ul>
                          </div>
                        )}
                      </li>
                      <li>
                        <Link to="/fund-transaction">
                          Fund Transaction Report
                        </Link>
                      </li>
                      <li>
                        <Link to="/cost-report">Cost Report</Link>
                      </li>
                      <li>
                        <Link to="/last-10-transaction-report">
                          Last 10 Transaction Report
                        </Link>
                      </li>
                    </ul>
                  </div>
                )}
              </li>
              {/* <li
                onMouseEnter={(e) => hoverFunction(e, Constants.RM_Mapping)}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to="/rm-mapping" className="side-blue rm-mapping">
                  <span className="icon-RM_mapping"></span>
                  <i>{Constants.RM_Mapping}</i>
                </Link>
              </li>

              <li
                onMouseEnter={(e) => hoverFunction(e, Constants.AP_Master)}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to="/ap-master" className="side-blue ap-master">
                  <span className="icon-Ap_master"></span>
                  <i>{Constants.AP_Master}</i>
                </Link>
              </li>
              <li
                onMouseEnter={(e) => hoverFunction(e, "Ap Payout")}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to="/ap-payout" className="side-blue ap-payout">
                  <span className="icon-Ap_payout"></span>
                  <i>Ap Payout</i>
                </Link>
              </li>
              <li
                onMouseEnter={(e) => hoverFunction(e, "RMS")}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to="/rms" className="side-blue rms">
                  <span className="icon-rms"></span>
                  <i>RMS</i>
                </Link>
              </li>

              <li
                onMouseEnter={(e) => hoverFunction(e, "Finance Rights")}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to="/finance-rights" className="side-blue AccountRights">
                  <span className="icon-Account_rights"></span>
                  <i>Finance Rights</i>
                </Link>
              </li>

              <li
                onMouseEnter={(e) => hoverFunction(e, "Banking")}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to="/banking" className="side-blue Banking">
                  <span className=" icon-banking"></span>
                  <i>Banking</i>
                </Link>
              </li> */}
              <li
                onMouseEnter={(e) => hoverFunction(e, "Family Master")}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to="/family-master" className="side-blue FamilyMaster">
                  <span className="icon-family-module"></span>
                  <i>Family Master</i>
                </Link>
              </li>
              <li
                onMouseEnter={(e) => hoverFunction(e, "IPO Master")}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to="/ipo-master" className="side-blue IPOMaster">
                  <span className="icon-ipo-module"></span>
                  <i>IPO Master</i>
                </Link>
              </li>

              <li
                onMouseEnter={(e) => hoverFunction(e, "Contact Us")}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to="/contact-us" className="side-blue ContactUs">
                  <span className="icon-faqs"></span>
                  <i>Contact Us</i>
                </Link>
              </li>

              <li
                onMouseEnter={(e) => hoverFunction(e, "Approve Brokerage")}
                onMouseLeave={removetooltip}
                onClick={removetooltip}
              >
                <Link to="/approvebrokerage" className="side-blue ApproveBrokerage">
                  <span className="icon-faqs"></span>
                  <i>Approve Brokerage</i>
                </Link>
              </li>
              {/* "RM Mapping page" */}
            </ul>
          )}
        </div>
      </div>
    </>
  );
}

export default Sidebar;
